/** DBCO-0059 - a duration in whole minutes as `HH:MM` (display only; the server computes every duration). */
export const formatMinutes = (minutes: number | null | undefined): string => {
  if (minutes === null || minutes === undefined || !Number.isFinite(minutes) || minutes < 0) {
    return "-";
  }
  const whole = Math.floor(minutes);
  const hours = Math.floor(whole / 60);
  const rest = whole % 60;
  return `${String(hours).padStart(2, "0")}:${String(rest).padStart(2, "0")}`;
};
